import { useNavigate } from "react-router-dom";
import PageHeader from "../../components/PageHeader";

const Success = () => {
  const navigate = useNavigate();

  const handleGoOrders = () => {
    navigate("/account/orders");
  };

  return (
    <div className="min-h-screen flex flex-col">
      <div className="flex-1 flex items-center justify-center px-4">
        <div className="bg-white rounded-xl shadow-md p-8 flex flex-col items-center">
          <svg
            className="w-16 h-16 text-green-500 mb-4"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            viewBox="0 0 24 24"
          >
            <circle
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              strokeWidth="2"
              fill="white"
            />
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M8 12l3 3 5-5"
            />
          </svg>
          <h2 className="text-2xl font-semibold text-gray-800 mb-2">
            Ödeme başarıyla gerçekleşti!
          </h2>
          <p className="text-gray-600 mb-6 text-center">
            Siparişiniz alındı. Sipariş detaylarını ve geçmişinizi görmek için
            aşağıdaki butona tıklayabilirsiniz.
          </p>
          <button
            onClick={handleGoOrders}
            className="bg-green-500 hover:bg-green-600 text-white font-medium py-2 px-6 rounded-lg transition-colors duration-200 shadow"
          >
            Siparişlerime Git
          </button>
        </div>
      </div>
    </div>
  );
};

export default Success;
